module.exports = "/assets/9331fa4825432aea3541ed5ae9a787fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SY.png
// module id = 2959
// module chunks = 0